/**
 * Price gate rule for gated B2B. Only an approved account can log in, so a
 * signed-in visitor is an approved one.
 *
 * `isHydrated` is false during SSR and on the first client render, which keeps
 * the markup identical for every visitor: cacheable, and no price flash.
 */
export const isPriceHidden = ({
	b2bAccess,
	isHydrated,
	hasUser
}: {
	b2bAccess: boolean;
	isHydrated: boolean;
	hasUser: boolean;
}) => b2bAccess && !(isHydrated && hasUser);
